import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { Trans, useTranslation } from 'react-i18next';
import MailToCustomerService from '@/components/MailToCustomerService';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const LoanWithdrawalFailed = ({ confirmAction, closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal', { keyPrefix: 'LoanWithdrawalFailed' });

  return (
    <Modal title={t('title')}>
      <p>
        <Trans t={t} i18nKey="body" components={{ customerServiceMail: <MailToCustomerService /> }} />
      </p>
      <ModalActions>
        <Button
          onClick={() => {
            closeModal();
            confirmAction?.();
          }}
        >
          {t('button')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default LoanWithdrawalFailed;
